<div class="timekeeping-view">

  <app-timekeeping-totals [cards]="store.totalsCards()"
                          (statusSelect)="onTotalsSelect($event)">
  </app-timekeeping-totals>

  <app-timekeeping-toolbar [searchQuery]="store.searchQuery()"
                           [filters]="store.filters()"
                           [agentTagOptions]="store.agentTagOptions()"
                           [groupTagOptions]="store.groupTagOptions()"
                           [groupOptions]="store.groupOptions()"
                           [branchOptions]="store.branchOptions()"
                           [selectedStatuses]="store.selectedStatuses()"
                           [range]="store.range()"
                           [exporting]="store.exporting()"
                           [exportingPayroll]="store.exportingPayroll()"
                           [completeDisabled]="store.completeDisabled()"
                           (searchChange)="onSearchChange($event)"
                           (agentTagsChange)="onAgentTagsChange($event)"
                           (groupTagsChange)="onGroupTagsChange($event)"
                           (groupIdsChange)="onGroupIdsChange($event)"
                           (branchIdsChange)="onBranchIdsChange($event)"
                           (statusesChange)="onStatusesChange($event)"
                           (rangeChange)="onRangeChange($event)"
                           (browseWeek)="onBrowseWeek($event)"
                           (exportTimecards)="onExportTimecards()"
                           (exportMileage)="onExportMileage()"
                           (exportPayroll)="onExportPayroll()"
                           (exportMondelezSummary)="onExportMondelezSummary()"
                           (openSettings)="onOpenSettings($event)"
                           (completeTimecards)="onComplete()">
  </app-timekeeping-toolbar>

  <div class="timekeeping-view-content">
    <!-- Initial load only -->
    @if (store.isInitialLoading()) {
      <div class="timekeeping-placeholder">
        <bz-spinner size="lg" [label]="'Loading timecards...' | translate"></bz-spinner>
        <p class="br-body-1 gray-106 margin-top-20">{{ 'Loading timecards...' | translate }}</p>
      </div>
    }

    <!-- Refresh overlay: shown when re-querying data (date/week change) while rows are already visible -->
    @if (store.showRefreshOverlay()) {
      <div class="timekeeping-refresh-overlay fade-element-in-only">
        <bz-spinner size="lg" [label]="'Loading' | translate"></bz-spinner>
      </div>
    }

    @if (store.showTable()) {
      <timecards-table [timecardGroups]="store.timeCardGroups()"
                       [dateRange]="store.range()"
                       [loading]="store.loading()"
                       [hasMoreData]="store.hasMoreData()"
                       [columns]="store.columns()"
                       [tableSettings]="store.tableSettings()"
                       (timecardSelect)="onSelectTimecard($event)"
                       (loadMore)="onLoadMore()"
                       (selectionChange)="onSelectionChange($event)"
                       (tableSettingsChange)="onTableSettingsChange($event)">
      </timecards-table>
    }
  </div>

</div>
